import * as Yup from 'yup'
import i18n from 'i18n'

/**
 * ======================================
 * F O R M   V A L U E S
 * ======================================
 */

export type FormValuesReports = {
  reportType: string
  startDate: string
  endDate: string
  playerId: string
  username: string
  game: string[]
  gameCategory: string[]
  gameProvider: any[]
  transactionTypePayment: string
  brandId: string
  balance: string
}

/**
 * ======================================
 * I N I T I A L   V A L U E S
 * ======================================
 */

export const initialValuesReports: FormValuesReports = {
  reportType: '',
  startDate: null,
  endDate: null,
  playerId: '',
  username: '',
  game: [],
  gameCategory: [],
  gameProvider: [],
  transactionTypePayment: '',
  brandId: '',
  balance: '',
}

/**
 * ======================================
 * V A L I D A T I O N S   S C H E M A S
 * ======================================
 */

const requiredString = Yup.string().required(i18n.t('error.requiredField'))

export const validationSchemaReports = Yup.object().shape({
  reportType: requiredString,
  startDate: requiredString,
  endDate: requiredString,
})
